import React from 'react';
import Script from 'next/script';
import { BlogPost } from '@adapters/prismic/types/blogPost';

export const SCHEMA_ORG = 'https://schema.org/';
export const MEC_URL = 'https://www.mec.ca/';

export const StructuredBlogData = ({ blogData }: { blogData: BlogPost }) => {
  const {
    first_publication_date: datePublished,
    last_publication_date: dateModified,
    data: { title, hero_image: heroImage },
  } = blogData;

  let pageUrl = '';
  if (typeof window !== 'undefined') {
    pageUrl = window?.location?.href;
  }

  const jsonLd = {
    '@context': SCHEMA_ORG,
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
      url: pageUrl,
    },
    headline: title,
    image: [heroImage?.url],
    datePublished,
    dateModified,
    publisher: {
      '@type': 'Organization',
      name: 'MEC',
    },
  };

  return (
    <Script id="blogpost-structured-search-data" type="application/ld+json">
      {JSON.stringify(jsonLd)}
    </Script>
  );
};
